import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { allCategories } from '@/utils/news';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
  };

  const isActive = (key: string) => location.pathname.startsWith(`/category/${key}`);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-background-200' : 'bg-background-50 border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center gap-4 md:gap-8">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-lg">
              9
            </span>
            <span className="font-heading font-black text-xl text-foreground-950 whitespace-nowrap">
              9·1牛网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {allCategories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(cat.key)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/contact"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/contact'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              联系我们
            </Link>
          </nav>

          <form onSubmit={submitSearch} className="hidden md:flex flex-1 justify-end">
            <div className="relative w-full max-w-xs">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯关键词"
                className="w-full h-9 pl-9 pr-3 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
              />
            </div>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <form onSubmit={submitSearch} className="mb-3">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯关键词"
                className="w-full h-10 pl-9 pr-3 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
              />
            </div>
          </form>
          <div className="flex flex-col">
            <Link to="/" className="px-2 py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-600">
              首页
            </Link>
            {allCategories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className="px-2 py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-600"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-2 py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-600">
              关于我们
            </Link>
            <Link to="/contact" className="px-2 py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-600">
              联系我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}